export default __webpack_public_path__ + "static/media/jose-maria.558935ba.jpg";